import { theme } from "uikit";

import OrderStatus from "../../../../../../../types/OrderStatus";
import { ShowCustomerPhoneNumbersType } from "../../../../../../../pages/Settings/pages/Orders/tabs/Orders/components/Modal/components/Content/tabs/Main/components/ShowCustomerPhoneNumbers";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model, orderSettings?: any) => {
	if (!item) return { content: "" };

	const transfer = item.additionalFields?.transfer;
	const fromPhones =
		transfer?.lastReceivedOrder?.phones?.at(-1)?.number ?? "";

	const isOwn = item?.isOwn ?? false;
	const hasExecutor = !!item?.executorToOrder?.length;

	const phone = isOwn ? item?.phones?.at(-1)?.number ?? "" : fromPhones;

	let content = "";
	if (isOwn || hasExecutor) {
		if (!(item.status === OrderStatus.CLOSED && !isOwn)) {
			content = phone;
		}
	}

	const isCreating =
		item.status === OrderStatus.CREATED ||
		item.status === OrderStatus.CREATING;

	const showConfig = orderSettings?.general?.showCustomerPhoneNumbers ?? {
		active: false,
	};

	const highlighted =
		showConfig.active &&
		showConfig.type === ShowCustomerPhoneNumbersType.Sometimes &&
		showConfig.conditions?.showManually &&
		item.additionalFields?.displaySettings?.showCustomerPhone;

	return {
		content,
		backgroundColor: isCreating ? theme.colors.disabled_text : undefined,
		textColor: isCreating ? theme.colors.white : undefined,
		highlighted,
	};
};

export default cellProcessing;
